import { generateCaptions } from 'redux/modules/automation-cms';
import { ThunkAction } from 'redux/types';

import { getUpdateTranscriptAction, removeCaptions } from './captions-ts';
import { TranscriptionConfig } from './types';

export const updateAudioCaptions = (
  initialConfig: TranscriptionConfig,
  updatedConfig: TranscriptionConfig,
  recordingId: number,
): ThunkAction<Promise<void>> => async dispatch => {
  const action = getUpdateTranscriptAction(initialConfig, updatedConfig);

  switch (action) {
    case 'add':
      await dispatch(
        generateCaptions(recordingId, updatedConfig.transcriptionLanguage),
      );
      break;
    case 'remove':
      dispatch(removeCaptions());
      break;
    case 'none':
    default:
      break;
  }
};
